<div class="card mb-5 mb-xl-8">
  <div class="card-header border-0 pt-5">
    <h3 class="card-title align-items-start flex-column">
      <span class="card-label fw-bold fs-3 mb-1">
        {{ "createNewUser" | translate }}
      </span>
    </h3>
    <button
      #closeEditModalBtn
      type="button"
      class="btn-close cursor-pointer"
      (click)="onCancel()"
      data-bs-dismiss="modal"
      aria-label="Close"
    ></button>
  </div>

  <div class="card-body py-3">
    <form [formGroup]="userForm" (ngSubmit)="saveUser($event)">
      <div class="row mb-4 gx-5">
        <!-- Organization -->
        <div
          class="col-md-6 mb-3"
          *ngIf="!currentUser?.userOrganizations?.length"
        >
          <label class="form-label required">{{
            "organizationLabel" | translate
          }}</label>
          <app-select
            formControlName="organizationId"
            [items]="organizations"
            bindLabel="name"
            bindValue="id"
            [clearable]="true"
            [multiple]="false"
            [placeholder]="'organizationLabel' | translate"
          ></app-select>
          <div
            *ngIf="isControlInvalid('organizationId')"
            class="text-danger fs-7 mt-1"
          >
            {{ "organizationIsRequired" | translate }}
          </div>
        </div>

        <!-- Facility -->
        <div
          class="mb-3"
          *ngIf="!isFacilityAdmin"
          [ngClass]="
            currentUser?.userOrganizations?.length ? 'col-md-12' : 'col-md-6'
          "
        >
          <label class="form-label required">{{
            "facility" | translate
          }}</label>
          <app-select
            formControlName="facilityId"
            [items]="facilities"
            bindLabel="name"
            bindValue="id"
            [clearable]="true"
            [multiple]="false"
            [placeholder]="'facility' | translate"
          ></app-select>
          <div
            *ngIf="isControlInvalid('facilityId')"
            class="text-danger fs-7 mt-1"
          >
            {{ "facilityIsRequired" | translate }}
          </div>
        </div>
      </div>

      <div class="row mb-4 gx-5">
        <!-- Role -->
        <div class="col-md-6 mb-3">
          <label class="form-label required">{{ "role" | translate }}</label>
          <app-select
            formControlName="roleId"
            [items]="roles"
            bindLabel="name"
            bindValue="id"
            [clearable]="true"
            [multiple]="false"
            [placeholder]="'role' | translate"
          ></app-select>
          <div *ngIf="isControlInvalid('roleId')" class="text-danger fs-7 mt-1">
            {{ "selectRole" | translate }}
          </div>
        </div>

        <!-- Name -->
        <div class="col-md-6 mb-3">
          <label class="form-label required">{{ "name" | translate }}</label>
          <input
            formControlName="name"
            type="text"
            class="form-control"
            placeholder="{{ 'name' | translate }}"
            (input)="preventForbiddenCharacters($event, 'text')"
          />
          <div *ngIf="isControlInvalid('name')" class="text-danger fs-7 mt-1">
            <ng-container *ngIf="userForm.get('name')?.hasError('required')">
              {{ "validation.required" | translate }}
            </ng-container>
            <ng-container *ngIf="userForm.get('name')?.hasError('minlength')">
              {{ "validation.minLength" | translate: { length: 2 } }}
            </ng-container>
            <ng-container *ngIf="userForm.get('name')?.hasError('maxlength')">
              {{ "validation.maxLength" | translate: { length: 100 } }}
            </ng-container>
            <ng-container *ngIf="userForm.get('name')?.hasError('pattern')">
              {{ "validation.onlyLetters" | translate }}
            </ng-container>
          </div>
        </div>
      </div>

      <div class="row mb-4 gx-5">
        <!-- Surname -->
        <div class="col-md-6 mb-3">
          <label class="form-label required">{{ "surname" | translate }}</label>
          <input
            formControlName="surname"
            type="text"
            class="form-control"
            placeholder="{{ 'surname' | translate }}"
            (input)="preventForbiddenCharacters($event, 'text')"
          />
          <div
            *ngIf="isControlInvalid('surname')"
            class="text-danger fs-7 mt-1"
          >
            <ng-container *ngIf="userForm.get('surname')?.hasError('required')">
              {{ "validation.required" | translate }}
            </ng-container>
            <ng-container
              *ngIf="userForm.get('surname')?.hasError('minlength')"
            >
              {{ "validation.minLength" | translate: { length: 2 } }}
            </ng-container>
            <ng-container
              *ngIf="userForm.get('surname')?.hasError('maxlength')"
            >
              {{ "validation.maxLength" | translate: { length: 100 } }}
            </ng-container>
            <ng-container *ngIf="userForm.get('surname')?.hasError('pattern')">
              {{ "validation.onlyLetters" | translate }}
            </ng-container>
          </div>
        </div>

        <!-- Gender -->
        <div class="col-md-6 mb-3">
          <label class="form-label required">{{ "gender" | translate }}</label>
          <app-select
            formControlName="gender"
            [items]="genders"
            bindLabel="name"
            bindValue="id"
            [clearable]="true"
            [multiple]="false"
            [placeholder]="'gender' | translate"
          ></app-select>
          <div *ngIf="isControlInvalid('gender')" class="text-danger fs-7 mt-1">
            {{ "genderIsRequired" | translate }}
          </div>
        </div>
      </div>

      <div class="row mb-4 gx-5">
        <!-- Date of Birth -->
        <div class="col-md-6 mb-3">
          <label class="form-label required">{{
            "dateOfBirth" | translate
          }}</label>
          <input
            formControlName="dateOfBirth"
            type="date"
            class="form-control"
            [max]="maxDate"
            min="1900-01-01"
          />
          <div
            *ngIf="isControlInvalid('dateOfBirth')"
            class="text-danger fs-7 mt-1"
          >
            <div *ngIf="userForm.get('dateOfBirth')?.hasError('required')">
              {{ "dateOfBirthIsRequired" | translate }}
            </div>
            <div *ngIf="userForm.get('dateOfBirth')?.hasError('oldDate')">
              {{ "patientCreate.validation.oldDate" | translate }}
            </div>
          </div>
        </div>

        <!-- Phone -->
        <div class="col-md-6 mb-3">
          <label class="form-label required">{{
            "phoneNumber" | translate
          }}</label>
          <ngx-intl-tel-input
            appPhoneInput
            [cssClass]="'form-control'"
            [enableAutoCountrySelect]="true"
            [enablePlaceholder]="true"
            [searchCountryFlag]="true"
            [searchCountryField]="[
              SearchCountryField.Iso2,
              SearchCountryField.Name,
            ]"
            [selectFirstCountry]="false"
            [selectedCountryISO]="defaultCountry"
            [maxLength]="15"
            [phoneValidation]="true"
            [separateDialCode]="true"
            formControlName="phoneNumber"
            name="phoneNumber"
          ></ngx-intl-tel-input>
          <div
            *ngIf="
              userForm.get('phoneNumber')?.invalid &&
              userForm.get('phoneNumber')?.touched
            "
            class="text-danger fs-7 mt-1"
          >
            <div *ngIf="userForm.get('phoneNumber')?.errors?.['required']">
              {{ "phoneNumberIsRequired" | translate }}
            </div>
            <div
              *ngIf="
                userForm.get('phoneNumber')?.errors?.['validatePhoneNumber']
              "
            >
              {{ "phoneNumberIsNotValid" | translate }}
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-4 gx-5">
        <!-- Email -->
        <div class="col-md-12 mb-3">
          <label class="form-label required">{{ "email" | translate }}</label>
          <input
            formControlName="email"
            type="email"
            class="form-control"
            placeholder="{{ 'email' | translate }}"
            (input)="preventForbiddenCharacters($event, 'email')"
          />
          <div *ngIf="isControlInvalid('email')" class="text-danger fs-7 mt-1">
            <div *ngIf="userForm.get('email')?.errors?.['required']">
              {{ "emailIsRequired" | translate }}
            </div>
            <div *ngIf="userForm.get('email')?.errors?.['email']">
              {{ "validation.validEmail" | translate }}
            </div>
            <div *ngIf="userForm.get('email')?.errors?.['maxlength']">
              {{ "validation.maxLength" | translate: { length: 50 } }}
            </div>
          </div>
        </div>
      </div>

      <!-- Buttons -->
      <div class="d-flex justify-content-end mt-8 gap-3">
        <button type="button" class="btn btn-secondary" (click)="onCancel()">
          {{ "cancel" | translate }}
        </button>

        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="userForm.invalid"
        >
          {{ "save" | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
